export const LEGAL_CONFIG = {
  privacyPolicyUrl: 'https://columbusholdco.eu/legal/beeking/beeking-privacy-policy',
  termsAndConditionsUrl: 'https://columbusholdco.eu/legal/beeking/beeking-terms-and-conditions',
} as const;
